var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq"},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","flex-direction":"column","max-width":"900px","margin":"0 auto"},attrs:{"id":"md"},domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}})])}
var staticRenderFns = []

export { render, staticRenderFns }